import { AiFillBook, AiFillHome } from "react-icons/ai";
import {
  MdGroup,
  MdContacts,
  MdSchool,
  MdFeedback,
  MdOutlineHelp,
} from "react-icons/md";
import { BsFillPersonFill } from "react-icons/bs";

import { create_UUID } from "helper/uuid";

export const CollegeSidePanelData = [
  {
    id: create_UUID(),
    name: "Dashboard",
    path: "/college/dashboard",
    icon: <AiFillHome />,
  },
  {
    id: create_UUID(),
    name: "Create Interview",
    path: "/college/create-interview",
    icon: <AiFillBook />,
  },
  {
    id: create_UUID(),
    path: "/college/my-interviews",
    name: "My Interviews",
    icon: <MdSchool />,
  },
  {
    id: create_UUID(),
    path: "/college/batches",
    name: "Batches",
    icon: <MdGroup />,
  },
  {
    id: create_UUID(),
    path: "/college/profile",
    name: "Profile",
    icon: <BsFillPersonFill />,
  },
  // {
  //   id: create_UUID(),
  //   path: "/college/plans",
  //   name: "Plans & Subscription",
  //   icon: <BsFillPersonFill />,
  // },
  {
    id: create_UUID(),
    path: "/college/support-feedback",
    name: "Support & Feedback",
    icon: <MdFeedback />,
  },
  // {
  //   id: create_UUID(),
  //   path: "/college/help",
  //   name: "Help & Documentation",
  //   icon: <MdOutlineHelp />,
  // },
];
